// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import styled from 'styled-components';

// Styles
import './customSelect.scss';

/**
 * CustomSelect Component
 *
 * @param {Object} props - React component props
 */
const customStyles = {
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#fff' : '#fff',
        border: 0,
        padding: 15,
    }),
    control: () => ({
        // none of react-select's styles are passed to <Control />
        display: 'flex',
        border: 0,
    }),

    menu: () => ({
        borderTop: '1px solid rgba(151, 151, 151, 0.13)',
        boxShadow: 'none',
    }),
};

const Spinner = styled.div`
    display: inline-block;
`;

const ErrorWrapper = styled.span`
    color: #f00;
    display: block;
    font-size: 12px;
    margin: 8px 0;
`;

const CustomSelect = props => {
    const {
        customClass,
        isMulti,
        isSearchable,
        isDisabled,
        autoFocus,
        onChange,
        options,
        menuIsOpen,
        placeholder,
        value,
        components,
        closeMenuOnSelect,
        formatGroupLabel,
        meta,
        selectProps,
        id,
        isLoading,
        onInputChange = () => { },
    } = props;
    // eslint-disable-next-line no-warning-comments
    // TODO remove this slice later and implement search because large data is causing performance issue
    return (
        <>
            <div className={`custom-select ${customClass ? customClass : ''}`}>
                <Select
                    {...selectProps}
                    classNamePrefix="react-select"
                    onChange={onChange}
                    options={options.slice(0, 500)}
                    id={id}
                    isMulti={isMulti}
                    isSearchable={isSearchable}
                    isDisabled={isDisabled}
                    autoFocus={autoFocus}
                    placeholder={placeholder}
                    components={components}
                    value={value}
                    styles={customStyles}
                    closeMenuOnSelect={closeMenuOnSelect}
                    hideSelectedOptions={false}
                    formatGroupLabel={formatGroupLabel}
                    menuIsOpen={menuIsOpen}
                    onInputChange={onInputChange}
                />
                {isLoading ? (
                    <Spinner className="spinner-wrap">
                        <div className="spinner" />
                    </Spinner>
                ) : null}
            </div>
            {meta && meta.touched && meta.error && (
                <ErrorWrapper className="error-message">
                    {meta.error}
                </ErrorWrapper>
            )}
        </>
    );
};

CustomSelect.propTypes = {
    autoFocus: PropTypes.bool,
    closeMenuOnSelect: PropTypes.bool,
    components: PropTypes.node,
    customClass: PropTypes.string,
    formatGroupLabel: PropTypes.func,
    isDisabled: PropTypes.bool,
    isMulti: PropTypes.bool,
    isSearchable: PropTypes.bool,
    onChange: PropTypes.func,
    options: PropTypes.array,
    placeholder: PropTypes.string,
    menuIsOpen: PropTypes.bool,
    meta: PropTypes.object,
    selectProps: PropTypes.object,
    id: PropTypes.string,
    isLoading: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    onInputChange: PropTypes.func,
};

export default CustomSelect;
